{
  "SelectOptionEmpty": {
    "noResults": "Brak wyników"
  },
  "UnitField": {
    "cm_long": "Metryczny (cm)",
    "cm": "cm",
    "in_long": "Imperialny (in)",
    "in": "in",
    "m_long": "Metryczny (m)",
    "m": "m",
    "ft_long": "Imperialny (ft)",
    "ft": "ft",
    "placeholders": {
      "feet": "Stopy",
      "inches": "Cale",
      "amount": "Kwota",
      "unit": "Jednostka"
    }
  }
}
